import { render, staticRenderFns } from "./ChatFansList.vue?vue&type=template&id=2cac3876&"
import script from "./ChatFansList.vue?vue&type=script&lang=js&"
export * from "./ChatFansList.vue?vue&type=script&lang=js&"
import style0 from "./ChatFansList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports